<template>
  <div class="skill" style="margin-bottom: 5px">
    <AssignmentEditor
      v-if="isAssignmentEditing"
      :isActive="isAssignmentEditing"
      :update:active="isAssignmentUpdated"
      :currentItem="Skill"
      :UpdateActive="isAssignmentUpdated"
      :Save="save"
      :ItemId="Skill.Id"
      ItemType="DataModel.TCVelik.Skill.TCSkill"
    >
    </AssignmentEditor>
    <vs-button
      v-if="!HideAssign"
      color="primary"
      type="flat"
      icon="link"
      @click="isAssignmentEditing = true"
      style="float: right"
      class="btn btn-primary"
      >Assign</vs-button
    >
    <!-- Scores badge -->
    <div
      v-if="!HideScore && this.Skill.MyScores < 0"
      class="dot-count text-center vs-avatar--count badgeNumber dot-count-danger"
    >
      {{ this.Skill.MyScores == -1 ? "0" : this.Skill.MyScores.toString() }}
    </div>
    <div
      v-if="!HideScore && this.Skill.MyScores >= -1 && this.Skill.MyScores < 1"
      class="dot-count text-center vs-avatar--count badgeNumber dot-count-unset"
    >
      {{ this.Skill.MyScores.toString() }}
    </div>
    <div
      v-if="!HideScore && this.Skill.MyScores > 0 && this.Skill.MyScores < 7"
      class="dot-count text-center vs-avatar--count badgeNumber dot-count-warning"
    >
      {{ this.Skill.MyScores.toString() }}
    </div>
    <div
      v-if="!HideScore && this.Skill.MyScores >= 7 && this.Skill.MyScores <= 9"
      class="dot-count text-center vs-avatar--count badgeNumber dot-count-success"
    >
      {{ this.Skill.MyScores.toString() }}
    </div>

    <div
      v-if="!HideScore && this.Skill.MyScores >= 10"
      class="dot-count text-center vs-avatar--count badgeNumber dot-count-coach"
    >
      {{ this.Skill.MyScores.toString() }}
    </div>

    <!-- / Scores badge -->

    <a
      :href="
        '/dashboard/skill-details/' +
        this.Skill.Id +
        (this.User ? '?forUser=' + this.User : '')
      "
      >{{ this.Skill.Title }}</a
    >
    <div style="margin-left: 32px">
      <small
        ><small
          ><strong>Category:</strong> {{ this.Skill.CategoryPath }}</small
        ></small
      >
    </div>
    <div v-if="!HideTags" style="margin-left: 32px">
      <TagList :tags="this.Skill.RelatedTags"> </TagList>
    </div>
    <slot name="PostSkill"></slot>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VTree from "@/views/components/extra-components/tree/Tree.vue";
import moment from "vue-moment";
import SkillScoringPopup from "@/views/components/extra-components/skillscoring/SkillScoringPopup.vue";
import TagList from "@/views/components/extra-components/taglist/TagList.vue";
import AssignmentEditor from "@/views/components/extra-components/assignments/AssignmentEditor.vue";
import SkillsService from "@/skills/skillsService.js";
import accountsService from "../../../../accounts/accountsService";

export default {
  data() {
    return {
      isAssignmentEditing: false,
    };
  },
  props: [
    "Skill",
    "User",
    "HideTags",
    "HideAssign",
    "HideScore",
    "AllowStateFilter",
    "AutoLoadForCurrentUser",
  ],
  methods: {
    save() {},
    isAssignmentUpdated(newVal) {
      this.$set(this, "isAssignmentEditing", newVal);
    },
    assignSkill() {
      this.$set(this, "isAssignmentEditing", true);
    },
    LoadForCurrentUser() {
      var instance = this;
      if (instance.Skill.Id && this.AutoLoadForCurrentUser) {
        // TODO: Get the skill scores for the current user.
        var currentUser = accountsService.getUserFromLocalStorage();
        SkillsService.getSkillByIdCalculated(
          instance.Skill.Id,
          currentUser.User.Id
        ).then(function (response) {
          if (response.data && (response.data.MyScores || response.data.MyScores == 0)) {
            instance.$set(instance.Skill, "MyScores", response.data.MyScores);
          }
        });
      }
    },
  },
  mounted() {
    if (this.AutoLoadForCurrentUser && this.Skill && this.Skill.Id > 0){
      this.LoadForCurrentUser();
    }
  },
  watch: {
    Skill(newVal) {
      if (this.AutoLoadForCurrentUser && newVal.Id && newVal.Id > 0){
        this.LoadForCurrentUser();
      }
    },
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VTree,
    moment,
    SkillScoringPopup,
    TagList,
    AssignmentEditor,
  },
};
</script>
<style lang="scss" scoped>
.skill {
  position: relative;
}
.project-skills .vs-avatar--count {
  float: left;
  margin-right: 2px;
  position: relative;
  margin-top: 7px;
  min-width: 30px;
}
.vs-avatar--count.badgeNumber {
  width: auto;
  height: auto;
  top: -3px;
  right: 0;
  border-radius: 4px;
  padding-left: 3px;
  padding-right: 3px;
  font-size: 0.625em;
  color: #fff;
  float: left;
  margin-right: 2px;
  position: relative;
  margin-top: 7px;
  min-width: 30px;
}
.dot-count-unset {
  background-color: #828282;
}

.dot-count-coach {
  background-color: rgb(2, 125, 207);
}
</style>
